import React from 'react';
import { Box, LoadingIndicator } from '@qga/roo-ui/components';

export const GenericLoadingIndicator = () => (
  <Box data-testid="loading-indicator" my={10}>
    <LoadingIndicator color="greys.alto" />
  </Box>
);
